import styled from 'styled-components';
import { colors, typography } from '../../styles/theme';

export const ClaimsToggleContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
`;

export const ToggleButton = styled.button`
  padding: 8px 24px;
  margin: 6px 0;
  border-radius: 12px;
  border: none;
  font-family: ${typography.fontFamily};
  font-size: ${typography.fontSize.sm};
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: ${props => props.selected ? colors.accent : colors.background};
  color: ${props => props.selected ? colors.primary : colors.text.secondary};
  font-weight: ${props => props.selected ? typography.fontWeight.medium : typography.fontWeight.normal};

  &:hover {
    background-color: ${colors.accent}40;
  }
`;

export const ClaimHistoryTitle = styled.h2`
  font-family: ${typography.fontFamily};
  font-size: ${typography.fontSize.xl};
  color: ${colors.text.primary};
  margin-bottom: 24px;
`;

export const ClaimsList = styled.div`
  margin: 24px 0 12px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;


export const AddClaimButton = styled.button`
  padding: 8px 24px;
  background-color: ${colors.accent};
  color: ${colors.primary};
  border: none;
  border-radius: 12px;
  font-family: ${typography.fontFamily};
  font-size: ${typography.fontSize.sm};
  font-weight: ${typography.fontWeight.medium};
  cursor: pointer;
  transition: all 0.2s ease;
  margin-left: auto;  // This will push the button to the right
  height: 48px;
  

  &:hover {
    background-color: ${colors.accent}40;
  }
`;

export const RemoveClaimButton = styled(AddClaimButton)`
  padding: 8px 24px;
  border-radius: 12px;
  height: 36px;
  background-color: ${colors.primary};
  color: ${colors.background};
  margin-left: auto;  // This will push the button to the right
  &:hover {
    background-color: ${colors.primary}CC;
  }
`;

export const ClaimHistoryContainer = styled.div`
  margin-top: 2rem;
  padding: 1.5rem;
  background: ${colors.background};
  border-radius: 8px;
`;

export const InputClaimsTitle = styled.h3`
  font-family: ${typography.fontFamily};
  font-size: ${typography.fontSize.sm};
  color: ${colors.text.primary};
  font-weight: ${typography.fontWeight.normal};
`;

export const ClaimItemWrapper = styled.div`
  font-family: ${typography.fontFamily};
  font-size: ${typography.fontSize.sm};
  color: ${colors.text.primary};
  font-weight: ${typography.fontWeight.normal};
`;

